<div
  class="dialog-header"
  [attr.data-type]="type"
  [ngStyle]="dialogHeaderStyle"
>
  <div class="header-content">
    <button
      class="back-button"
      *ngIf="showBackButton"
      type="button"
      aria-label="Go back"
      (click)="handleBackClick()"
    >
      <umss-icon name="phosphorArrowLeft" size="20px"></umss-icon>
    </button>
    <div class="title-section">
      <h2 class="title" *ngIf="title">{{ title }}</h2>
      <p class="subtitle" *ngIf="subtitle">{{ subtitle }}</p>
    </div>
    <button
      class="close-button"
      *ngIf="showCloseButton"
      type="button"
      aria-label="Close dialog"
      (click)="handleCloseClick()"
    >
      <umss-icon name="phosphorX" size="20px"></umss-icon>
    </button>
  </div>
</div>
